
export const StoreConstant = {
    reducers: {
        accountPermissions: 'accountPermission',
        grantRevokePermissions: 'grantRevokePermissions',
        granteeReducer: 'granteeReducer',   //TODO: Rename the reducer
    },
};
